import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0F0F0F",
      "fill-rule": "evenodd",
      d: "M3.458 7.336 2.397 8.397l3.2 3.2 1.06 1.06 1.06-1.06 6.715-6.716-1.06-1.06-6.715 6.715z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }